<template>
	<section class="Section">
		<div class="Container WhiteBox">
			<div class="BoxWide">
				<div class="Bookmark"><span>Entita</span></div>
			</div>                      
            <FiltroEntita @FiltraEntita ="filtraEntita($event)" @RimuoviFiltri="this.rimuoviFiltri"></FiltroEntita>             
        </div>
        <div class = "Container"> 
            <GrigliaEntita :listaEntita="this.listaEntita"></GrigliaEntita>
        </div>      
    </section>      
</template>

<script>
import { apiMixin, entitaMixin } from "/mixin.js"
import Entita from '@/models/entita.model'
import FiltroEntita  from "@/components/FiltroEntita.vue"
import GrigliaEntita from "@/components/GrigliaEntita.vue"

export default {
    name: "Entita",
    mixins:[apiMixin, entitaMixin],
    data(){
        return {
            listaEntita:[],
            listaEntitaOriginale:[]
        }
    },
    components:{
        FiltroEntita,
        GrigliaEntita
    },
    mounted: function(){
        this.doApiCall("get", "entita/GetEntitaWeb", this.$store.getters.getUtente.Token).then(
            (data) => {
                if(data){
                    this.listaEntita = data.map(o => {                      
                        return Object.assign(new Entita(), o)                        

                    });           
                    this.listaEntitaOriginale = this.listaEntita;                 
                }
            }
        );   
    }     
}

</script>
